module.exports = {
    showStats: false,
    resolution: {width:1024, height:768},
    loadscreen: {
        loadbar:{
            position:{x:250, y:650}
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 29
// module chunks = 0